module.exports = __webpack_public_path__ + "img/dynamic2.1427ddb3.png";